import { SYSTEM_TAG_PARTNER, type SystemTag } from '@app/shared/lib/partner-tags';

/**
 * Konfigurace pohledu pro `PartnersPage` — jedna komponenta, více režimů.
 *
 * V samostatném (ne-lazy) modulu, aby je `route-tree.tsx` mohl importovat
 * eager a předat lazy-loadnuté komponentě jako prop (config musí být známý
 * při renderu, samotná stránka se code-splituje).
 */
export interface PartnersViewConfig {
  /** Route path pro `useSearch`/`useNavigate` from-context. */
  routePath: '/partners' | '/partneri';
  title: string;
  description: string;
  /** Label tlačítka pro vytvoření kontaktu. */
  addLabel: string;
  /** Titulek karty se seznamem. */
  listTitle: string;
  /** Zpráva v prázdném stavu. */
  emptyMessage: string;
  /** Zobrazit role chip toggles (Zákazník / Partner). */
  showRoleToggles: boolean;
  /** Systémový tag vždy přibalený k filtru (a default pro create modal). */
  lockedSystemTag?: SystemTag;
}

/** Výchozí konfigurace pro obecný Adresář (`/partners`). */
export const ADDRESS_BOOK_CONFIG: PartnersViewConfig = {
  routePath: '/partners',
  title: 'Adresář',
  description:
    'Sjednocený adresář všech kontaktů — zákazníci, partneři/dodavatelé i kontakty bez aktivity. Štítky pro segmentaci, filtrace dle role nebo vlastních tagů.',
  addLabel: '+ Přidat kontakt',
  listTitle: 'Seznam kontaktů',
  emptyMessage: 'Žádné kontakty neodpovídají filtru.',
  showRoleToggles: true,
};

/** Konfigurace pro správcovskou sekci Partneři (`/partneri`). */
export const PARTNERS_CONFIG: PartnersViewConfig = {
  routePath: '/partneri',
  title: 'Partneři',
  description:
    'Partneři a dodavatelé s přístupem do partnerského portálu. Nový kontakt zde automaticky dostane štítek „Partner".',
  addLabel: '+ Přidat partnera',
  listTitle: 'Seznam partnerů',
  emptyMessage: 'Žádní partneři neodpovídají filtru.',
  showRoleToggles: false,
  lockedSystemTag: SYSTEM_TAG_PARTNER,
};
